// Tiedoston tallennus käyttäjälle.
//
// Selaimessa tiedosto ladataan tavallisesti. Android-sovelluksen WebView ei
// tue selaimen latauslinkkejä, joten siellä tiedosto kirjoitetaan sovelluksen
// välimuistiin ja avataan Androidin jakovalikko: käyttäjä valitsee itse,
// tallentaako tiedoston, lähettääkö sen sähköpostilla vai avaako toisessa
// sovelluksessa (esim. GPX karttasovelluksessa).

import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";

import { isNativeApp } from "./api.js";

export async function saveTextFile(filename, text, mimeType) {
  if (isNativeApp()) {
    const { uri } = await Filesystem.writeFile({ path: filename, data: text, directory: Directory.Cache, encoding: Encoding.UTF8 });
    await Share.share({ title: filename, files: [uri] });
    return;
  }
  const url = URL.createObjectURL(new Blob([text], { type: mimeType }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Vapautetaan vasta hetken päästä: osa selaimista aloittaa latauksen viiveellä.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
